<template>
  <user-actions-form :title="title">
    <template v-slot:form>
      <span class="label">Nombre:</span>
      <v-text-field
        :rules="[rules.requiredName]"
        outlined
        dense
        class="input-text input-text--text-field"
        v-model="form.name"
        type="text"
      ></v-text-field>
      <span class="label">Correo electrónico:</span>
      <v-text-field
        :rules="[rules.requiredEmail, rules.email]"
        outlined
        dense
        class="input-text input-text--text-field"
        v-model="form.email"
        type="text"
      ></v-text-field>
      <span class="label">Contraseña:</span>
      <v-text-field
        :rules="[rules.requiredPass]"
        outlined
        dense
        class="input-text input-text--text-field"
        v-model="form.password"
        type="password"
      ></v-text-field>
      <span class="label">Confirma contraseña:</span>
      <v-text-field
        :rules="[rules.requiredPass]"
        outlined
        dense
        class="input-text input-text--text-field"
        v-model="form.confirmPassword"
        type="password"
      ></v-text-field>
      <v-btn class="v-btn--primary" type="submit" block> Reestablecer </v-btn>
    </template>
  </user-actions-form>
</template>

<script>
import UserActionsForm from "../Shared/Form/UserActionsForm.vue";
import { mapGetters } from "vuex";
export default {
  components: { UserActionsForm },
  data() {
    return {
      title: "Reestablecer Contraseña",
      form: {
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
      },
    };
  },
 
    computed: {
      ...mapGetters({
        rules: "bibles/getRules",
      }),
      validation() {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const name_val =
          this.form.name.split("").filter((e) => e !== "").length > 0 &&
          this.form.name.length > 0;
        const email_val =
          this.form.email.split("").filter((e) => e !== "").length > 0 &&
          this.form.email.length > 0 &&
          pattern.test(this.form.email);
        const password_val =
          this.form.password.split("").filter((e) => e !== "").length > 0 &&
          this.form.password.length > 0 &&
          this.form.password === this.form.confirmPassword;
        return name_val && email_val && password_val;
      },
      passError() {
        return (
          this.form.password !== this.form.confirmPassword &&
          !!this.form.confirmPassword
        );
      },
    },
};
</script>